import { useApiConfiguration } from 'src/ui/shared/hooks/api-configuration.hook';

export const useIsJobsEnabled = () => {
    const { value } = useApiConfiguration();
    return value?.settings?.disableJobs !== true;
};
